import type { HTMLAttributes } from 'react'
import cx from 'classnames'
import styles from './UnreadBadge.module.css'

interface UnreadBadgeProps extends HTMLAttributes<HTMLSpanElement> {
  count: number
}

/**
 * A badge with an unread count, capped at 99+.
 */
export function UnreadBadge({ count, className, ...rest }: UnreadBadgeProps) {
  return (
    <span className={cx(styles.root, className)} {...rest}>
      {count > 99 ? '99+' : count}
    </span>
  )
}
